"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var FileModels_1 = require("../../Models/FileModels");
var drag_drop_1 = require("@angular/cdk/drag-drop");
var AuthHeaders_1 = require("../../api/AuthHeaders");
var http_1 = require("@angular/common/http");
var forms_1 = require("@angular/forms");
var service_service_1 = require("../../Services/service.service");
var router_1 = require("@angular/router");
var WickedApiClient_1 = require("../../api/WickedApiClient");
var environment_1 = require("src/environments/environment");
var ImageAttachComponent = /** @class */ (function () {
    function ImageAttachComponent(HttpClient, fb, services, route) {
        this.HttpClient = HttpClient;
        this.fb = fb;
        this.services = services;
        this.route = route;
        this.maxAttachments = -1;
        this.imagesChanged = false;
        this.maxAttachmentsExceeded = new core_1.EventEmitter();
        this.setImagesIsUploaded = new core_1.EventEmitter();
        this.This = this;
        this.images = [];
        this.title = "Drag files here";
        this.subtitle = "";
    }
    ImageAttachComponent.prototype.ngOnInit = function () {
    };
    Object.defineProperty(ImageAttachComponent.prototype, "selectedImage", {
        get: function () {
            return this._selectedImage;
        },
        set: function (value) {
            if (value != this._selectedImage) {
                this.imagesChanged = true;
            }
            this._selectedImage = value;
        },
        enumerable: true,
        configurable: true
    });
    ImageAttachComponent.prototype.uploadFile = function (file) {
        var _this = this;
        var url = "/File/TemporaryUpload";
        var formData = new FormData();
        var token = AuthHeaders_1.getAuthToken();
        var headers = new http_1.HttpHeaders(); //.set('Content-Type', 'multipart/form-data');
        var httpRequestParams = new http_1.HttpParams();
        headers.set("Authorization", "Bearer " + token);
        formData.set("file", file.file, file.file.name);
        this.services.progress = true;
        this.HttpClient.post(url, formData, {
            headers: headers,
            observe: "events",
            params: httpRequestParams,
            reportProgress: true,
            responseType: "json"
        }).subscribe(function (event) {
            if (event.type === http_1.HttpEventType.UploadProgress) {
                file.progressPercentage = Math.floor((event.loaded * 100) / event.total);
                file.loaded = event.loaded;
            }
            if (event.type == http_1.HttpEventType.Response) {
                var eventResponse = event;
                if (eventResponse.body && eventResponse.ok) {
                    file.fileName = eventResponse.body.files[0].localFilename;
                    file.isUploading = false;
                    file.imageUrl = environment_1.environment.apiBaseUrl + "/FileGet/" + file.fileName;
                }
                if (_this.images.length > 0) {
                    _this.setImagesIsUploaded.emit(true);
                }
                _this.services.progress = false;
            }
        }, function (error) {
            file.isUploading = false;
            _this.services.progress = false;
        }, function () {
        });
    };
    ImageAttachComponent.prototype.isImage = function (file) {
        var name = file.name.toLowerCase();
        return name.endsWith(".jpg") || name.endsWith(".gif") || name.endsWith(".png") || name.endsWith(".jpeg") || name.endsWith(".bmp");
    };
    ImageAttachComponent.prototype.addFiles = function (files) {
        if (this.images.length + files.length > this.maxAttachments) {
            this.maxAttachmentsExceeded.emit();
            return;
        }
        else {
            for (var i = 0; i < files.length; i++) {
                this.addFile(files[i]);
            }
        }
    };
    ImageAttachComponent.prototype.addFile = function (file) {
        var _this = this;
        if (this.isImage(file)) {
            var fi_1 = new FileModels_1.FileInfo();
            fi_1.file = file;
            fi_1.fileName = file.name;
            fi_1.name = file.name;
            fi_1.orgFileName = file.name;
            var reader_1 = new FileReader();
            reader_1.onload = function (e) {
                fi_1.imageUrl = reader_1.result;
                _this.images.push(fi_1);
                _this.updateImageIndexes();
                _this.uploadFile(fi_1);
                if (!_this.selectedImage) {
                    _this.selectedImage = fi_1;
                }
                _this.imagesChanged = true;
            };
            reader_1.readAsDataURL(fi_1.file);
        }
    };
    ImageAttachComponent.prototype.deleteImage = function (file) {
        this.images = this.images.filter(function (x) { return x.orderIndex != file.orderIndex; });
        this.images.forEach(function (img, index) {
            img.orderIndex = index;
        });
        if (this.selectedImage == file) {
            if (this.images.length > 0) {
                this.selectedImage = this.images[0];
            }
            else {
                this.selectedImage = undefined;
            }
            //  this.selectedImage =
        }
        if (this.images.length < 1) {
            this.setImagesIsUploaded.emit(false);
        }
        this.imagesChanged = true;
    };
    ImageAttachComponent.prototype.entered = function (event) {
        console.log("entered");
    };
    ImageAttachComponent.prototype.dtoImages = function () {
        return this.images.map(function (img) {
            var dtoImg = new WickedApiClient_1.DTOImage();
            dtoImg.init({ orgFileName: img.orgFileName, fileName: img.fileName });
            return dtoImg;
        });
    };
    ImageAttachComponent.prototype.drop = function (event) {
        if (event.previousIndex != event.currentIndex) {
            drag_drop_1.moveItemInArray(this.images, event.previousIndex, event.currentIndex);
            this.updateImageIndexes();
            this.imagesChanged = true;
        }
    };
    ImageAttachComponent.prototype.onFileSelected = function (event) {
        var inputNode = event.target;
        var fileList = inputNode.files;
        if (this.maxAttachments < 1 || this.images.length + fileList.length > this.maxAttachments) {
            this.maxAttachmentsExceeded.emit();
            this.fileInput.nativeElement.value = "";
            return;
        }
        for (var i = 0; i < fileList.length; i++) {
            this.addFile(fileList.item(i));
        }
        this.fileInput.nativeElement.value = "";
    };
    ImageAttachComponent.prototype.updateImageIndexes = function () {
        this.images.forEach(function (img, index) {
            img.orderIndex = index;
        });
    };
    ImageAttachComponent.prototype.overAction = function (i) {
    };
    ImageAttachComponent.prototype.cdkDragStarted = function ($event, childItem, i) {
    };
    ImageAttachComponent.prototype.cdkDragReleased = function ($event, i) {
    };
    ImageAttachComponent.prototype.clear = function () {
        this.images = [];
    };
    return ImageAttachComponent;
}());
exports.ImageAttachComponent = ImageAttachComponent;
